module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "loading-text"
  }, [_c('li', {
    class: {
      'active': _vm.textIndex === 0
    }
  }, [(_vm.locale === 'en') ? _c('img', {
    attrs: {
      "src": require("assets/unsupported/lockup.png")
    }
  }) : _vm._e(), (_vm.locale !== 'en') ? _c('img', {
    attrs: {
      "src": require("assets/lockup.png")
    }
  }) : _vm._e()]), _vm._l((_vm.text), function(lines, index) {
    return _c('li', {
      class: {
        'active': _vm.textIndex === (index + 1)
      }
    }, _vm._l((lines), function(line) {
      return _c('p', [_vm._v(_vm._s(line))])
    }))
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7286eb47"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading/LoadingText.vue
// module id = 309
// module chunks = 1